import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import { EndpointTypes } from 'src/models/Channels/endpointType';

export const campaignTypeToEndpointType = {
  [CampaignType.EMAIL]: EndpointTypes.EMAIL,
  [CampaignType.SMS]: EndpointTypes.SMS,
  [CampaignType.VOICE]: EndpointTypes.VOICE,
};
